"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRandomColor = getRandomColor;
/**
 * Generates colors which are not highly saturated.
 * Use this for backgrounds.
 * @param {boolean} filterWhite Whether or not to return white color
 * @returns hex color in string format.
 */
function getRandomColor() {
  var filterWhite = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var letters = '0123456789ABCDEF';
  var black = '#000000';
  var whitish = ['#FFFFFF', '#FFFAFA', '#F0FFF0', '#F5FFFA', '#F0FFFF', '#F0F8FF', '#F8F8FF', '#F5F5F5', '#FFF5EE', '#F5F5DC', '#FDF5E6', '#FFFAF0', '#FFFFF0', '#FAEBD7', '#FAF0E6', '#FFF0F5', '#FFE4E1', '#FFDEAD', '#E8E8E8', '#D1D1D1', '#BABABA', '#A3A3A3', '#8C8C8C'];
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  if (filterWhite && whitish.includes(color.toUpperCase())) {
    return black;
  }
  return color;
}